import type { AppDispatch } from "../store";
import { removeTemplateHtmlById } from "../metadata/metadataSlice";
import { getTemplateIdVersionKey } from "../../components/TemplateBuilder/utils/getTemplateHtml";

export function invalidateTemplateHtmlCacheEntry(
  dispatch: AppDispatch,
  templateId?: string,
  versionValue?: string,
): string {
  const cacheKey = getTemplateIdVersionKey(templateId, versionValue);

  if (!cacheKey) {
    return "";
  }

  dispatch(removeTemplateHtmlById({ templateId: cacheKey }));

  return cacheKey;
}